import { Router } from 'vue-router';
import NavigationService from '../../services/NavigationService';

export default function setupHistoryHook(router: Router): void {
  router.afterEach((to, from) => NavigationService.handleNavigation(from, to));
}
